<prizm-doc-page class="info-page" header="SLA">
  <p>Настоящее соглашение определяет политику взаимоотношений при использовании дизайн-системы Prizm.</p>
  <p class="warning-agreement">Ссылки в скором времени будут актуализированы</p>

  <h1>1. Лицензия</h1>
  <p>
    Дизайн-система Prizm и часть* её зависимых компонентов распространяются под открытой
    <a href="">лицензией MIT</a>, текст лицензионного соглашения дублируется непосредственно в самих
    репозиториях.
  </p>
  <p class="addition">
    * некоторые части дизайн-системы Prizm, например, картографический виджет, виджет управления
    наряд-заказами и другие, могут лицензироваться самостоятельно и отсутствовать в публичном доступе.
  </p>

  <h1>2. Стратегия версионирования</h1>
  <h3>2.1 Схема версионирования</h3>
  <p>
    Во всех зависимых компонентах экосистемы Цифры применяется стратегия
    <a href="">[RFC] Prizm Версионирование</a>.
  </p>
  <p>
    Использование дополнительных постфиксов для предварительных релизов и сборок с мета-обозначениями
    допускается, но сохранение в них обратной совместимости не гарантируется, поскольку эти версии не являются
    конечными.
  </p>

  <h3>2.2 Жизненный цикл версий</h3>
  <p>
    Основной фокус делается на поддержку и стабилизацию крайней major-версии, а пересмотр предложений, которые
    потенциально нарушают обратную совместимость, допускается не чаще чем раз в полгода для отдельно взятого
    компонента. Отчетный период начинается с даты последнего релиза.
  </p>

  <h3>2.3 Механизм оповещений</h3>
  <p>
    2.3.1 Для оперативного информирования о новых версиях ведется
    <a href="https://t.me/prizmdesign">канал в Telegram</a>.
  </p>
  <p>
    2.3.2 Для получения сводной информации обо всех изменениях в программном коде рекомендуется использовать
    механизм 🔗наблюдения за проектом.
  </p>
  <p>
    2.3.3 В случаях, когда сохранение обратной совместимости невозможно в силу наличия потенциальных
    уязвимостей или серьезных проблем с производительностью применяется механизм 🔗
    <a href="https://docs.npmjs.com/cli/v7/commands/npm-deprecate">deprecated</a>.
  </p>

  <h3>2.4 История версий</h3>
  <p>Полная история изменений по всем версиям продуктов доступна на 🔗<a href="">страницах</a> с релизами.</p>

  <h1>3. Доступность и поддержка</h1>
  <p>Направления, за которые отвечает команда Prizm:</p>
  <ol class="disc">
    <li>Исправление критических дефектов.</li>
    <li>Стратегическое планирование.</li>
    <li>
      Поддержка и развитие информационных ресурсов
      <ol>
        <li><a href="http://prizm.zyfra.com/">Основной информационный ресурс</a></li>
        <li>
          <a href="http://doc.prizm.zyfra.com/">Витрина компонентов</a> и
          <a href="https://prizm.site/">зеркало</a>
        </li>
        <li>
          <a href="https://www.figma.com/community/file/1156311020501452261"
            >Библиотека компонентов в Figma Community</a
          >
        </li>
        <li><a href="https://github.com/zyfra/Prizm">Исходный код библиотеки компонентов</a></li>
        <li><a href="https://t.me/prizmdesign">Информационный канал в Telegram</a></li>
      </ol>
    </li>
  </ol>
  <p>
    Задачи информационного наполнения, расширения функциональности и исправления незначительных дефектов мы
    стараемся раздеделять с нашими контрибьюторами.
  </p>

  <h1>4. Системные ограничения</h1>
  <h3>4.1 Браузеры</h3>
  <p>
    Ориентируйтесь на то, что все основные компоненты дизайн-системы протестированы и корректно отображаются в
    браузерах, которые поддерживает Angular. Это включает в себя следующие конкретные версии браузеров:
  </p>
  <table class="table" prizmTable size="l">
    <thead>
      <tr prizmThGroup>
        <th prizmTh>Браузер</th>
        <th prizmTh>Поддреживаемые версии</th>
      </tr>
    </thead>

    <tbody [data]="browserVersions" prizmTbody>
      <ng-container *prizmRow="let item of browserVersions; let i = index">
        <tr prizmTr>
          <td prizmTd>{{ item.name }}</td>
          <td prizmTd>{{ item.description }}</td>
        </tr>
      </ng-container>
    </tbody>
  </table>

  <h3>4.2 Разрешения экранов</h3>
  <p>
    Разрешение экранов, которые смело можно учитывать при проектировании интерфейсов для полноразмерных
    устройств: 1280×720, 1366×768, 1440×900, 1920×1080.
  </p>

  <h1>5. Типы тикетов и порядок их заведения</h1>
  <p>
    Дефекты, запросы на новую функциональность или вопросы оформляются в виде 🔗<a
      href="https://github.com/zyfra/Prizm/issues"
      >тикета на GitHub</a
    >
  </p>
  <p>Возможные типы тикетов:</p>
  <table class="table" prizmTable size="l">
    <thead>
      <tr prizmThGroup>
        <th prizmTh>Тип тикета</th>
        <th prizmTh>Расшифровка</th>
      </tr>
    </thead>

    <tbody [data]="labelTypes" prizmTbody>
      <ng-container *prizmRow="let item of labelTypes; let i = index">
        <tr prizmTr>
          <td prizmTd>{{ item.name }}</td>
          <td prizmTd>{{ item.description }}</td>
        </tr>
      </ng-container>
    </tbody>
  </table>
  <p>
    🔗
    <a href="">Рекомендации оформления</a>
    тикетов:
  </p>
  <ol class="disc">
    <li>
      При создании тикетов с типом bug необходимо использовать шаблон оформления баг-репорта (Bug report).
    </li>
    <li>
      При создании тикетов с типами feature или improvement необходимо использовать шаблон запроса фичи или
      улучшения (Feature request).
    </li>
  </ol>

  <h1>6. Время реагирования</h1>
  <p>В течение 5 рабочих дней с момента появления нового тикета применяется следующий алгоритм:</p>
  <ol class="disc">
    <li>Если тикет понятен, и вопросов нет, ему присваивается тип и приоритет.</li>
    <li>
      Если для правильной категоризации тикета требуются уточнения (обсуждение происходит в комментариях), то
      тип и приоритет присваиваются после получения ответов.
    </li>
  </ol>

  <h3>6.1 Как определяется приоритет</h3>
  <p>На приоритет тикета влияют следующие факторы:</p>
  <ol class="disc">
    <li>
      Потребность проектов Цифровой индустриальной платформы (совместное предприятие ГЦ «Цифра» и ПАО «Газпром
      нефть»).
    </li>
    <li>Экспертное мнение команды дизайн-системы Prizm.</li>
    <li>Популярность компонента в других системах</li>
    <li>Подробное описание с понятными формулировками проблем или предложений.</li>
    <li>Высокая активность пользователей.</li>
  </ol>

  <h1>7. Сроки реализации*</h1>
  <p>Сроки реализации тикетов зависят от категории и приоритета:</p>
  <ol class="disc">
    <li>
      Если за реализацию берется команда Prizm, то сроки реализации будут соответствовать представленным в
      таблице ниже.
    </li>
    <li>Если за реализацию берется внешняя команда, то сроки реализации могут отличаться.</li>
    <li>
      Если реализация задачи требует предварительного исследования или дизайна, то создается отдельная задача
      с меткой research или design.
    </li>
  </ol>
  <table class="table" prizmTable size="l">
    <thead>
      <tr prizmThGroup>
        <th prizmTh>Приоритет</th>
        <th prizmTh>Категория</th>
        <th prizmTh>Реализация</th>
      </tr>
    </thead>

    <tbody [data]="implementationTimeline" prizmTbody>
      <ng-container *prizmRow="let item of implementationTimeline; let i = index">
        <tr prizmTr>
          <td prizmTd>{{ item.priority }}</td>
          <td prizmTd>{{ item.name }}</td>
          <td prizmTd>{{ item.description }}</td>
        </tr>
      </ng-container>
    </tbody>
  </table>

  <h1>8. Актуализация бэклога</h1>
  <p>
    Актуализация бэклога и пересмотр приоритетов всех тикетов происходит не более трёх раз в квартал. По
    итогам пересмотра приоритет тикета может быть как поднят, так и понижен.
  </p>

  <h3>8.1 Причины закрытия тикетов</h3>
  <p>В рамках актуализации бэклога тикет может быть закрыт по следующим причинам:</p>
  <ol class="disc">
    <li>Дубликат.</li>
    <li>Задача уже реализована.</li>
    <li>Входит в другой тикет.</li>
    <li>Задача потеряла актуальность.</li>
    <li>Не получены ответы на уточняющие вопросы или неполное описание.</li>
    <li>Обоснованный отказ команды Prizm.</li>
  </ol>

  <h1>9. Запросы на принятие изменений</h1>
  <p>
    Изменения и доработки, предлагаемые контрибьютерами, 🔗<a href="">оформляются</a> в виде 🔗<a href=""
      >запросов на принятие изменений</a
    >
  </p>
  <p>
    При появлении нового PR/MR команда Prizm в течение двух рабочих дней проводит 🔗<a href="">ревью</a>
    и, при отсутствии критичных замечаний, принимает PR/MR.
  </p>
  <p>
    К мержу допускаются PR/MR, получившие не менее двух аппрувов. Изменения включаются в следующий релиз.
    Релизы выпускаются раз в две недели. День недели будет определен похже опытным путём.
  </p>
</prizm-doc-page>
